import "./MGAlertModal.css"

export default function MGAlertModal({
    content
}) {
    return (
        <div className="modal-overlay">
            <div className="alert-modal ">
                {content}
            </div>
        </div>
    );
}